import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Radio, Button } from 'antd';
// utils
import { getAbsenceTypeLabel } from 'utils/helpers/helper.generateData';

function AbsenceTypeForm({
  formData,
  // actions
  nextStep,
  prevStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-communication', className);

  const [isDisabled, setIsDisabled] = useState(true);

  const [AbsFormType] = Form.useForm();

  /* 
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData && formData?.type) {
      AbsFormType.setFieldsValue(formData);
      setIsDisabled(false);
    }
  }, [formData]);

  const onFinish = values => {
    !!result && result(values);
    !!nextStep && nextStep();
    AbsFormType.resetFields();
  };

  const options = [
    {
      key: 'medical',
      value: 'medical',
      label: (
        <>
          <span
            className="label__title"
            style={{ textTransform: 'capitalize' }}
          >
            {getAbsenceTypeLabel('medical')}
          </span>
          <span className="label__description">
            Rendez-vous médicale, opérations, blessure, rééducation,…
          </span>
        </>
      ),
    },
    {
      key: 'no-medical',
      value: 'no-medical',
      label: (
        <>
          <span
            className="label__title"
            style={{ textTransform: 'capitalize' }}
          >
            {getAbsenceTypeLabel('no-medical')}
          </span>
          <span className="label__description">
            Motifs familiaux, déplacement à l’étranger, ….
          </span>
        </>
      ),
    },
    {
      key: 'sickness',
      value: 'sickness',
      label: (
        <>
          <span
            className="label__title"
            style={{ textTransform: 'capitalize' }}
          >
            {getAbsenceTypeLabel('sickness')}
          </span>
          <span className="label__description">
            L’élève est malade et ne peut pas participer au(x) cour(s)
          </span>
        </>
      ),
    },
  ];

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormType}
        className="form-communication__form"
        name="form_absence_type"
        initialValues=""
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item name="type">
          <Radio.Group
            className="radio-group radio-group--big"
            options={options}
            optionType="Radio"
          />
        </Form.Item>

        <div className="absence-actions-wrapper">
          <Button
            className="next-btn"
            form="form_absence_type"
            htmlType="submit"
            disabled={isDisabled}
          >
            Suivant
          </Button>
        </div>
      </Form>
    </div>
  );
}

AbsenceTypeForm.defaultProps = {};
AbsenceTypeForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
};

export default memo(AbsenceTypeForm);
